import cn from "classnames";
import { CSSProperties } from "react";

import Editorials from "~/types/editorials";

import styles from "./loyalty-steps.module.scss";

type Props = {
  steps: Editorials.LoyaltyStepsModel[];
  isBackgroundGradient?: boolean;
};

export default function LoyaltySteps(props: Props) {
  const { steps, isBackgroundGradient } = props;
  const styleSteps = { "--number-steps": steps.length } as CSSProperties;

  return (
    <div style={styleSteps} className={styles.container}>
      <LoyaltyStepsMobile
        steps={steps}
        isBackgroundGradient={isBackgroundGradient}
        classNames={styles.mobileOnly}
      />
      <LoyaltyStepsDesktop
        steps={steps}
        isBackgroundGradient={isBackgroundGradient}
        classNames={styles.desktopOnly}
      />
    </div>
  );
}

function LoyaltyStepsMobile(props: Props & { classNames?: string }) {
  const { steps, isBackgroundGradient, classNames } = props;

  return steps.map((step, index) => {
    const { title, description } = step;
    return (
      <div
        key={index}
        className={cn(
          styles.cardMobile,
          classNames,
          isBackgroundGradient ? styles.removeBorder : undefined,
        )}
      >
        <span className={styles.indexMobile}>{index + 1}</span>
        <div>
          <p className={styles.title}>{title}</p>
          {description && <p className={styles.description}>{description}</p>}
        </div>
      </div>
    );
  });
}

function LoyaltyStepsDesktop(props: Props & { classNames?: string }) {
  const { steps, isBackgroundGradient, classNames } = props;

  return steps.map((step, index) => {
    const { title, description } = step;
    return (
      <div
        key={index}
        className={cn(
          styles.card,
          classNames,
          isBackgroundGradient ? styles.removeBorder : undefined,
        )}
      >
        <div
          className={cn(
            styles.headingCard,
            isBackgroundGradient ? styles.backgroundWhite : undefined,
          )}
        >
          <span className={styles.index}>{index + 1}</span>
          <p className={styles.title}>{title}</p>
        </div>
        {description && <p className={styles.description}>{description}</p>}
      </div>
    );
  });
}
